export const ROOT_API = "https://dtalks-api.site";
export const API_HEADER = {
  "Content-Type": "application/json",
  "Access-Control-Allow-Origin": "*",
};